import { module } from 'angular';

export const VPC_MODULE = 'spinnaker.amazon.vpc';
module(VPC_MODULE, [
  require('./vpcTag.directive').name
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/vpc/vpc.module.ts